export const PAGE = 1;
export const PAGE_SIZE = 20;
export const DEFAULT_PAGINATION = {
  page: PAGE,
  pageSize: PAGE_SIZE,
  total: 0,
  lastPage: 0,
};

/* 
FIXME: 기간한정 상품 긴급 오류로 가격 하드코딩 처리함. 긴급 오류로 일단 하드코딩으로함, 수정 이후에 반드시 하드코딩 제거해야함. (화면 표기용, 실제 결제 금액은 서버 가격)
  - _LqCq2-aTnnl6qqO: [기간 한정] 베이직 코스 온라인 연장 혜택(13개월)
  - 9JZdO8zwbMpQR_ue: [기간 한정] 키즈 코스 온라인 연장 혜택(13개월)
  */
export const DISPLAY_PRICE_OVERRIDES: Record<string, number> = {
  '_LqCq2-aTnnl6qqO': 360000, // [기간 한정] 베이직 코스 온라인 연장 혜택(13개월)
  '9JZdO8zwbMpQR_ue': 120000, // [기간 한정] 키즈 코스 온라인 연장 혜택 (13개월)
};
